import { defineComponent, watch } from "@vue/composition-api";

import { provideNotification } from "./modules/notification";
import { provideClient } from "./modules/client";
import { provideUser } from "./modules/user";
import { provideAccount } from "./modules/account";
import { provideDialog } from "./modules/dialog";
import { provideNote } from "./modules/note";
import { provideBookmark } from "./modules/bookmark";
import { provideTask } from "./modules/task";
import { provideTaskWs } from "./modules/task_ws";
import { provideMeritAktivaWs } from "./modules/merit_aktiva.js";
import { provideSmartAccountsStore } from "./modules/smart_accounts.js";
import { provideApp } from "./modules/app";
import { provideTopic } from "./modules/topic";
import { provideCustomFields } from "./modules/custom_fields";
import { provideTimer } from "./modules/timer";
import { provideProduct } from "./modules/product";
import { provideProductField } from "./modules/product_field";
import { provideContract } from "./modules/contract";
import { provideClientGroup } from "./modules/client_groups";
import { providePurchase } from "./modules/purchase";
import { provideSalesInvoice } from "./modules/sales_invoice";
import { provideLoading } from "./modules/loading";
import { provideError } from "./modules/error";
import { provideActivity } from "./modules/activity";
import { provideEvent } from "./modules/calendar_event";
import { provideReport } from "./modules/report";
import { provideFeature } from "./modules/feature";
import { provideFeedbackNotification } from "@/store/modules/feedback_notification";
import { provideSubscription } from "./modules/subscription";
import { provideClassifier } from "./modules/classifier";
import { provideAppStoreDialog } from "./modules/AppStoreDialog/appStoreDialog";
import { provideTaskButton } from "@/store/modules/task_button";
import { provideSupplier } from "@/store/modules/supplier";
import { provideProject } from "@/store/modules/project";
import { provideClientBilling } from "./modules/client_billing";
import { provideBreadcrumbs } from "./modules/breadcrumbs";
import { provideEmailAutomation } from "./modules/email_automation";
import { provideRole } from "./modules/role";
import {provideEmailSignature} from "../api/email_automation/email_signature";
import { provideDocuments } from './modules/documents';

export const StoreProvider = defineComponent({
    setup() {
        provideNotification();
        provideClient();
        provideUser();
        provideAccount();
        provideDialog();
        provideNote();
        provideBookmark();
        provideApp();
        provideTask();
        provideTaskWs();
        provideMeritAktivaWs();
        provideTopic();
        provideCustomFields();
        provideTimer();
        provideProduct();
        provideProductField();
        provideContract();
        provideClientGroup();
        providePurchase();
        provideSalesInvoice();
        provideError();
        provideLoading();
        provideActivity();
        provideEvent();
        provideReport();
        provideClassifier();
        provideFeature();
        provideSubscription();
        provideAppStoreDialog();
        provideTaskButton();
        provideSupplier();
        provideProject();
        provideTaskButton();
        provideClientBilling();
        provideBreadcrumbs();
        provideEmailAutomation();
        provideRole();
        provideFeedbackNotification();
        provideEmailSignature()
        provideDocuments();
        provideSmartAccountsStore();

        return {};
    },
    render(h) {
        return h("div", this.$slots.default);
    }
});
